import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaConciergeBell, FaWineGlassAlt, FaUtensils, FaHeart, FaGift, FaCalendarCheck, FaStar, FaBuilding, FaSun, FaPaintBrush, FaRulerCombined, FaGlobe, FaCar, FaCalendarDay, FaAllergies, FaTemperatureHigh, FaLeaf, FaPepperHot, FaStore } from 'react-icons/fa';


// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'custom catering':
      return <FaConciergeBell />; // Fire extinguisher icon

    case 'event planning':
      return <FaCalendarAlt />; // Graduation cap icon

    case 'private dining':
      return <FaWineGlassAlt />; // Tools icon

    case 'menu customization':
      return <FaUtensils />; // Users/people icon

    case 'corporate catering':
      return <FaBriefcase />; // Search icon

    case 'special occasions':
      return <FaHeart />; // Shield icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
    case 'time':
      return <FaClock />; // Clock icon

    case 'duration':
    case 'preparationtime':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
    case 'capacity':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
    case 'venue':
    case 'address':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'price':
    case 'pricerange':
    case 'pricing':
    case 'admission':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'headchef':
    case 'organizer':
    case 'eventplanner':
      return <FaUserTie />; // Leader icon

    case 'phonenumber':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    case 'eventtype':
      return <FaCalendarDay />; // Calendar Day icon

    case 'cuisine':
    case 'portionsize':
      return <FaUtensils />; // Utensils icon (food-related)

    case 'includes':
      return <FaGift />; // Gift icon (included items or perks)

    case 'booking':
      return <FaCalendarCheck />; // Calendar Check icon (booking-related)

    case 'specialfeatures':
    case 'rating':
      return <FaStar />; // Star icon (features or ratings)

    case 'venuetype':
      return <FaBuilding />; // Building icon (venue type)

    case 'indooroutdoor':
      return <FaSun />; // Sun icon (indoor/outdoor setting)

    case 'styledecor':
      return <FaPaintBrush />; // Paint Brush icon (style or decor)

    case 'area':
      return <FaRulerCombined />; // Ruler icon (area measurement)

    case 'website':
      return <FaGlobe />; // Globe icon (website or online presence)

    case 'parking':
      return <FaCar />; // Car icon (parking availability)

    case 'allergens':
      return <FaAllergies />; // Allergies icon (allergen information)

    case 'servingtemperature':
      return <FaTemperatureHigh />; // High Temperature icon (serving temperature)

    case 'dietaryinfo':
      return <FaLeaf />; // Leaf icon (dietary or vegetarian info)

    case 'spicelevel':
      return <FaPepperHot />; // Hot Pepper icon (spice level)

    case 'availablefor':
      return <FaStore />; // Store icon (availability type: dine-in, delivery, etc.)

    case 'recommendedpairing':
      return <FaWineGlassAlt />; // Wine Glass icon (pairing recommendation)

    default:
      return null; // Return null if no matching icon is found
  }

};